<template lang="pug">
  #ChatRoomIndex.chatroom.h-100.overflow-hidden
    appHeader(
      :hasBackTool="true",
      :headerType="'title'",
      :title="`與 ${userName} 對話`"
    )
    .container-width.h-100
      .chatroom__mainPart.content-body.h-100
        .content.p-2.h-100#content(
          ref="contentBody"
        )
          components(
            v-for="msg in chatMessages",
            :key="msg.id",
            :is="watchMsgsType(msg)",
            :messageData="msg.messageData",
            v-if="watchMsgsType(msg) !== 'null'",
            :timeData="msg.time"
          )
    .chatroom__footerPart
      ChatroomFooter.h-100(
        @sendHandler="sendHandler"
      )
    SitckerModel(
      @sendHandler="sendHandler",
      title="貼圖"
    )
    TempModel(
      title="訊息模板"
    )
    TagModel(
      title="顧客標籤"
    )
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import ChatroomFooter from '@/components/chat/ChatroomFooter.vue';
import SitckerModel from '@/components/customerModel/stickerModel.vue';
import TempModel from '@/components/customerModel/tempModel.vue';
import TagModel from '@/components/customerModel/tagModel.vue';
import TitleDate from '@/components/chat/system/TitleDate.vue';

// 測試用圖片
import SaProfileUrl from '@/assets/images/example/sa_1.png';
import MemberProfileUrl from '@/assets/images/example/sa_2.png';

// 顧客
import MText from '@/components/chat/member/M-Text.vue';
import MImg from '@/components/chat/member/M-Img.vue';
import MVideo from '@/components/chat/member/M-Video.vue';
import MSticker from '@/components/chat/member/M-Sticker.vue';

// 顧問
import PText from '@/components/chat/personnel/P-Text.vue';
import PImg from '@/components/chat/personnel/P-Img.vue';
import PVideo from '@/components/chat/personnel/P-Video.vue';
import PSticker from '@/components/chat/personnel/P-Sticker.vue';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'ChatRoomIndex',
  components: {
    appHeader,
    ChatroomFooter,
    TempModel,
    SitckerModel,
    TagModel,
    TitleDate,
    MText,
    MImg,
    MVideo,
    MSticker,
    PText,
    PImg,
    PVideo,
    PSticker
  },
  mounted() {
    this.firstLoad();
    this.$store.commit('toggleLoading', false);
  },
  data() {
    return {
      userName: '小白兔',
      testMsg: [
        {
          id: 0,
          previewComponent: 'text',
          direction: 'm2p',
          send_at: '2020-10-19 10:10:00',
          message: {
            profileImg: MemberProfileUrl,
            type: 'text',
            text: '您好，請問能協助我嗎？',
            time: '2020-10-19 10:10:00'
          }
        },
        {
          id: 1,
          previewComponent: 'text',
          direction: 'p2m',
          send_at: '2020-10-21 21:12:30',
          message: {
            profileImg: SaProfileUrl,
            type: 'text',
            text: '您好，需要什麼協助呢？',
            time: '2020-10-21 21:12:30'
          }
        },
        {
          id: 2,
          previewComponent: 'text',
          direction: 'm2p',
          send_at: '2020-10-21 22:10:10',
          message: {
            profileImg: MemberProfileUrl,
            type: 'text',
            text: '我想要更換為這位顧問',
            time: '2020-10-21 22:10:10'
          }
        },
        {
          id: 3,
          previewComponent: 'image',
          direction: 'm2p',
          send_at: '2020-10-21 22:12:34',
          message: {
            profileImg: MemberProfileUrl,
            type: 'image',
            file: null,
            preview_url: SaProfileUrl,
            time: '2020-10-21 22:12:34'
          }
        }
      ],
      chatMessages: [], // 聊天記錄
      oldMessagePushArr: [], // 拿來放打 api 拿到的舊聊天記錄的陣列
      currentPage: 1 // 目前頁數
    };
  },
  methods: {
    // 檢查型態
    watchMsgsType(msg) {
      // 顧客對顧問
      if (msg.direction === 'm2p') {
        if (msg.previewComponent === 'text') {
          return 'm-text';
        }
        if (msg.previewComponent === 'image') {
          return 'm-img';
        }
        if (msg.previewComponent === 'video') {
          return 'm-video';
        }
        if (msg.previewComponent === 'sticker') {
          return 'm-sticker';
        }
        return 'null';
      } if (msg.direction === 'p2m') {
        if (msg.previewComponent === 'text') {
          return 'p-text';
        }
        if (msg.previewComponent === 'image') {
          return 'p-img';
        }
        if (msg.previewComponent === 'video') {
          return 'p-video';
        }
        if (msg.previewComponent === 'sticker') {
          return 'p-sticker';
        }
        return 'null';
      } if (msg.previewComponent === 'titleDate') {
        return 'titleDate';
      }
        return 'null';
    },
    firstLoad() {
      const vm = this;
      // 先清空聊天記錄
      vm.$set(vm, 'chatMessages', []);
      // 清空舊的聊天記錄陣列
      vm.$set(vm, 'oldMessagePushArr', []);
      // 強制回覆聊天記錄分頁的頁數
      vm.$set(vm, 'currentPage', 1);

      // 判斷是否最後一頁的資料，讓塞資料時知道最上方是否要塞時間
      const isLastPage = true;

      _.forEach(vm.testMsg, (val, index) => {
        // data 用來放要塞進陣列的資料
        let data = null;
        // 如果是所有資料到頂的第一筆，最上方一定要插入時間，時間就是這筆資料的時間
        if (isLastPage === true && index === 0) {
          // 如果不是 插入一個時間的 components
          data = {
            previewComponent: 'titleDate',
            time: val.send_at
          };
          // 把整理好的日期格式丟進陣列顯示出來
          vm.chatMessages.push(data);
        }
        // 將傳送的資料整理成前端顯示需要的格式
        data = {
          id: val.id,
          member_uuid: '123123123',
          previewComponent: val.previewComponent,
          messageData: val.message
        };
        // 將發送時間丟進 messageData
        data.messageData.time = val.send_at;

        // 判斷是 user 傳送或是 host 傳送
        // m2p 為 user 傳送 => '會員to顧問'
        if (val.direction === 'm2p') {
          data.direction = 'm2p';
          data.previewComponent = `${val.message.type}`;
        } else {
          // 其餘都是 host 傳送
          // p2m => '顧問to會員', s2m => '系統to會員', s2p => '系統to顧問'
          // 先判斷是不是模板 (只有這邊傳給使用者會有模板)
          // TODO: 模板部分尚未處理
          if (val.message.type === 'template') {
            const templateData = JSON.parse(val.message).data;
            // 模板要一個一個塞回去
            _.forEach(templateData, (value) => {
              // 這個要放裡面 不然跑完迴圈都會抓到最後一筆
              const newData = {
                id: _.cloneDeep(data.id),
                member_uuid: _.cloneDeep(data.member_uuid),
                previewComponent: `host_${value.type}`,
                messageData: _.cloneDeep(value)
              };
              // 自己加入時間 (因為template裡的data沒有時間)
              newData.messageData.time = _.cloneDeep(val.send_at);
              // 把整理好的格式丟進陣列顯示出來
              vm.chatMessages.push(newData);
            });
            // 把 previewComponent 變回空才不會重複新增到
            data.previewComponent = null;
          } else {
            data.direction = 'p2m';
            data.previewComponent = `${val.message.type}`;
          }
        }
        // 把整理好的格式丟進陣列顯示出來
        vm.chatMessages.push(data);

        // 這邊去判斷是否需要多塞一個時間的 components
        // 檢查和下一筆資料的日期是否相同
        // 如果是這批資料的最後一筆，最新的一筆，不必往下塞時間
        // 剩下和陣列內下一筆比時間
        let nextDataDateTime = null;
        if ((index + 1) === vm.testMsg.length) {
          // 這批資料的最後一筆：最新的一筆，不必塞往下時間
        } else {
          // 取得下一筆 index 的時間
          nextDataDateTime = moment(vm.testMsg[index + 1].send_at).format('MM-DD-YYYY');
          // 取得時間資料的年月日格式
          const sendAtDate = moment(val.send_at).format('MM-DD-YYYY');
          if (sendAtDate !== nextDataDateTime) {
            // 如果不是 插入一個時間的 components
            data = {
              previewComponent: 'titleDate',
              time: vm.testMsg[index + 1].send_at
            };
            // 把整理好的格式丟進陣列顯示出來
            vm.chatMessages.push(data);
          }
        }
    });

    // 再次強制回覆聊天記錄分頁的頁數
    vm.$set(vm, 'currentPage', 1);
    // 聊天室置底
    vm.setChatScroll();
    },
    sendHandler(data) {
      console.log('發送資訊', data);
      const vm = this;
      if (!data || !data.type) return;
      switch (data.type) {
        case 'text':
          vm.receiveMessage({
            id: vm.chatMessages.length,
            previewComponent: 'text',
            direction: 'p2m',
            send_at: moment().format('YYYY-MM-DD HH:mm:ss'),
            messageData: {
              profileImg: SaProfileUrl,
              type: 'text',
              text: data.text,
              time: moment().format('YYYY-MM-DD HH:mm:ss')
            }
          });
          vm.setChatScroll();
          break;
        case 'image':
          vm.$swal.fire({
            title: '上傳中',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          setTimeout(() => {
            vm.receiveMessage({
              id: vm.chatMessages.length,
              previewComponent: 'image',
              direction: 'p2m',
              send_at: moment().format('YYYY-MM-DD HH:mm:ss'),
              messageData: {
                profileImg: SaProfileUrl,
                type: 'image',
                file: data.file,
                preview_url: data.src,
                time: moment().format('YYYY-MM-DD HH:mm:ss')
              }
            });
            vm.$swal.close();
            vm.setChatScroll();
          }, 2000);
          break;
        case 'video':
          vm.$swal.fire({
            title: '上傳中',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          setTimeout(() => {
            vm.receiveMessage({
              id: vm.chatMessages.length,
              previewComponent: 'video',
              direction: 'p2m',
              send_at: moment().format('YYYY-MM-DD HH:mm:ss'),
              messageData: {
                profileImg: SaProfileUrl,
                type: 'video',
                file: data.file,
                preview_url: data.src,
                time: moment().format('YYYY-MM-DD HH:mm:ss')
              }
            });
            vm.$swal.close();
            vm.setChatScroll();
          }, 2000);
          break;
        case 'sticker':
          vm.receiveMessage({
            id: vm.chatMessages.length,
            previewComponent: 'sticker',
            direction: 'p2m',
            send_at: moment().format('YYYY-MM-DD HH:mm:ss'),
            messageData: {
              profileImg: SaProfileUrl,
              type: 'sticker',
              package_id: 'val.package_id',
              sticker_id: 'val.sticker_id',
              time: moment().format('YYYY-MM-DD HH:mm:ss')
            }
          });
          vm.setChatScroll();
          break;
        default:
          break;
      }
    },
    // 接收訊息
    receiveMessage(messageData) {
      const vm = this;
      let lastSendAt = null;
      if (vm.chatMessages.length !== 0) {
        // 上一則訊息的時間
        const lastMessage = vm.chatMessages[vm.chatMessages.length - 1];
        lastSendAt = moment(lastMessage.messageData.time).format('MM-DD-YYYY');
      }
      // 先判斷是不是同個年月日
      const sendAtDate = moment(messageData.send_at).format('MM-DD-YYYY');
      // data 用來放要塞進陣列的資料
      let data = null;

      // 這邊去判斷是否需要多塞一個時間的 components
      if (sendAtDate !== lastSendAt) {
        // 如果時間不同 插入一個時間的 components
        data = {
          previewComponent: 'titleDate',
          time: messageData.send_at
        };
        // 把整理好的格式丟進陣列顯示出來
        vm.chatMessages.push(data);
      }

      // 上面檢查是否需要丟時間完成後繼續跑丟資料的程式碼, 整理成我們需要的格式
      data = {
        id: messageData.id,
        member_uuid: messageData.line_uuid,
        previewComponent: null,
        messageData: messageData.messageData
      };

      // 判斷是 user 傳送或是 host 傳送
      // m2p 為 user 傳送 => '會員to顧問'
      if (messageData.direction === 'm2p') {
        data.direction = 'm2p';
        data.previewComponent = `${messageData.messageData.type}`;
      } else {
        // 其餘都是 host 傳送
        // p2m => '顧問to會員', s2m => '系統to會員', s2p => '系統to顧問'
        // 先判斷是不是模板
        // TODO: 模板部分尚未處理
        if (messageData.messageData.type === 'template') {
          const templateData = JSON.parse(JSON.stringify(messageData.messageData)).data;

          // 模板要一個一個塞回去
          for (let i = 0; i < templateData.length; i++) {
            // 這個要放裡面 不然跑完迴圈都會抓到最後一筆
            const newData = {
              id: data.id,
              member_uuid: data.member_uuid,
              previewComponent: `host_${templateData[i].type}`,
              messageData: templateData[i]
            };
            // 自己加入時間 (因為template裡的data沒有時間)
            newData.messageData.time = messageData.send_at;
            // 把整理好的格式丟進陣列顯示出來
            vm.chatMessages.push(newData);
          }
          // 把 previewComponent 變回空才不會重複新增到
          data.previewComponent = null;
        } else {
          data.direction = 'p2m';
          data.previewComponent = `${messageData.messageData.type}`;
        }
      }
      // 這邊判斷 Component 是否是空的 如果前一個是 template 就可能為空 不是空在往聊天記錄陣列內丟
      if (data.previewComponent !== null) {
        // 把整理好的資料丟進去
        vm.chatMessages.push(data);
      }

      // 聊天室置底
      vm.setChatScroll();
    },
    // 聊天室置底
    setChatScroll() {
      // 聊天室 scollbar 置底
      setTimeout(() => {
        const el = document.querySelector('#content');
        el.scrollTop = el.scrollHeight - el.clientHeight;
      }, 100);
    }
  }
};
</script>

<style>

</style>
